import { cn } from '@/lib/utils';
import { ImageDetails } from '@/services/api/contracts/catalog/types';
import { FC, HTMLAttributes } from 'react';
import { Blurhash } from 'react-blurhash';

interface PictureProps extends HTMLAttributes<HTMLDivElement> {
  image: ImageDetails;
  alt?: string;
  full?: boolean;
  containerHeight: number;
  containerWidth: number;
}

export const Picture: FC<PictureProps> = ({
  image,
  alt,
  full = false,
  className,
  containerHeight,
  containerWidth,
  ...props
}) => {
  const ratio = image.ratio;

  const heightFromWidth = (w: number) => w * ratio;
  const widthFromHeight = (h: number) => h / ratio;

  let heightToUse = containerHeight;
  let widthToUse = widthFromHeight(containerHeight);

  if (widthToUse > containerWidth) {
    widthToUse = containerWidth;
    heightToUse = heightFromWidth(widthToUse);
  }

  const top = (containerHeight - heightToUse) / 2;
  const left = (containerWidth - widthToUse) / 2;

  return (
    <div className={cn(`relative`, className)} style={{ height: containerHeight, width: containerWidth }} {...props}>
      <div style={{ height: heightToUse, width: widthToUse, top, left }} className="absolute overflow-clip">
        <Blurhash hash={image.hash} width={widthToUse} height={heightToUse} />
      </div>
      <img
        loading="lazy"
        className="absolute"
        style={{ height: heightToUse, width: widthToUse, top, left }}
        src={full ? image.original : image.thumbnail}
        alt={alt}
      />
    </div>
  );
};
